import React from "react";

const RatesTable = () => {
  const dropPickupRates = [
    { name: "WagonR", seating: "3 + 1D", amount: "₹1800 + Toll" },
    { name: "Sedan", seating: "4 + 1D", amount: "₹2000 + Toll" },
    { name: "Ertiga", seating: "6 + 1D", amount: "₹2500 + Toll" },
    { name: "Toyota Rumion", seating: "6 + 1D", amount: "₹2700 + Toll" },
    { name: "Toyota Innova", seating: "6 + 1D", amount: "₹3800 + Toll" },
    { name: "Innova Crysta", seating: "6 + 1D", amount: "₹4200 + Toll" },
  ];

  const outstationRates = [
    { name: "WagonR", seating: "3 + 1D", amount: "₹11 per km, ₹300 package charge" },
    { name: "Sedan", seating: "4 + 1D", amount: "₹12 per km, ₹300 package charge" },
    { name: "Ertiga", seating: "6 + 1D", amount: "₹14 per km, ₹300 package charge" },
    { name: "Toyota Rumion", seating: "6 + 1D", amount: "₹16 per km, ₹300 package charge" },
    { name: "Toyota Innova", seating: "6 + 1D", amount: "₹20 per km, ₹300 package charge" },
    { name: "Innova Crysta", seating: "6 + 1D", amount: "₹22 per km, ₹300 package charge" },
  ];

  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Our Rates
        </h2>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Drop – Pickup Rates Table */}
          <div className="overflow-x-auto">
            <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">
              Drop – Pickup Rates
            </h3>
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow">
              <thead className="bg-blue-600 text-white">
                <tr>
                  <th className="py-3 px-4 text-left">Vehicle</th>
                  <th className="py-3 px-4 text-center">Seating</th>
                  <th className="py-3 px-4 text-left">Rate</th>
                </tr>
              </thead>
              <tbody>
                {dropPickupRates.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-3 px-4">{item.name}</td>
                    <td className="py-3 px-4 text-center">{item.seating}</td>
                    <td className="py-3 px-4">{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Outstation Rates Table */}
          <div className="overflow-x-auto">
            <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">
              All Outstation Rates
            </h3>
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow">
              <thead className="bg-green-600 text-white">
                <tr>
                  <th className="py-3 px-4 text-left">Vehicle</th>
                  <th className="py-3 px-4 text-center">Seating</th>
                  <th className="py-3 px-4 text-left">Rate</th>
                </tr>
              </thead>
              <tbody>
                {outstationRates.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-3 px-4">{item.name}</td>
                    <td className="py-3 px-4 text-center">{item.seating}</td>
                    <td className="py-3 px-4">{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RatesTable;
